import { encrypt, decrypt } from './cryptojs';

export function loadState(key) {
  try {
    const serializedState = localStorage.getItem(key);
    // if (serializedState === null) {}
    return JSON.parse(decrypt(serializedState));
  } catch (err) {
    return undefined;
  }
};

export function saveState(state, key) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, encrypt(serializedState));
  } catch {
    // ignore write errors
  }
};

export function removeItems(keys) {
  keys.map(element => {
    return localStorage.removeItem(element);
  });
};